import { DateTime } from "luxon"

import Dashboard from "@/features/dashboards/components/Dashboard"
import type { KPIGroupRequest } from "@/types/kpiTypes"

export default function PEPL() {
  const gasMetricsConfig: KPIGroupRequest = {
    aggType: "Monthly",
    asOf: DateTime.now().startOf("day").toJSDate(),
    returnSize: 6,
    kpis: [
      {
        $type: "calc",
        name: "Raw Inlet Gas per Minute",
        unit: "SCFM",
        expression: "[60] / 1.44",
        aggFunction: "Average",
        location: 6,
        typeId: 1,
      },
      {
        $type: "basic",
        id: 60,
        typeId: 1,
        location: 6,
      },
      {
        $type: "basic",
        id: 65,
        typeId: 1,
        location: 6,
      },
      {
        $type: "basic",
        id: 61,
        typeId: 1,
        location: 6,
      },
      {
        $type: "calc",
        name: "Max kWh",
        unit: "kWh",
        aggFunction: "Sum",
        location: 6,
        expression: "[61]/225*800*24",
        padding: 32,
        typeId: 1,
      },
      {
        $type: "calc",
        name: "Efficiency",
        unit: "%",
        aggFunction: "Average",
        location: 6,
        expression: "100 * [260]/([61]/225*800*24)",
        padding: 32,
        typeId: 1,
      },
      { $type: "basic", id: 260, location: 6, typeId: 1 },
      {
        $type: "calc",
        name: "Average Power",
        unit: "kW",
        aggFunction: "Average",
        location: 6,
        expression: "[260]/24",
        padding: 32,
        typeId: 1,
      },
      {
        $type: "basic",
        id: 270,
        location: 6,
        typeId: 1,
      },
    ],
  }

  return (
    <Dashboard
      config={{
        kpiTable: {
          request: gasMetricsConfig,
          paddingArray: [16, 16, 32, 16, 32, 32, 16, 16, 16],
        },
        rollingChart: {
          totalDays: 180,
          averageDays: 7,
          primaryKPIs: [
            {
              $type: "basic",
              id: 260,
              location: 6,
              typeId: 1,
            },
          ],
          secondaryKPI: { $type: "basic", id: 61, location: 6, typeId: 1 },
          label: "Rolling Power Trend",
        },
      }}
    />
  )
}
